import PrepaidPrintPackagesPurchase from './PrepaidItemsPurchase';
import withModal from '../modal/withModal';

export const PREPAID_ITEMS_PURCHASE_MODAL = 'modal/PREPAID_ITEMS_PURCHASE';

export default withModal(PrepaidPrintPackagesPurchase, {
  name: PREPAID_ITEMS_PURCHASE_MODAL,
  contentLabel: 'Purchase Packages & Prints',
  className: 'prepaid-items-purchase-modal',
  size: 'sm',
  type: 'full',
});
